import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useApprovesList() {
  // Use toast
  const toast = useToast();

  const refApproveListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "id", label: "請求編號", sortable: true },
    { key: "supplier.company_name_cn", label: "放債人名稱", sortable: true },
    /* { key: "is_member", label: "會員", sortable: true }, */
    { key: "supplier.membership_expiry_date", label: "會員到期日", sortable: true },
    { key: "supplier.search_limit", label: "剩餘搜尋次數", sortable: true },
    { key: "approve_note", label: "批核備註" },
    { key: "reject_reason", label: "拒絕原因" },
    { key: "signed_date", label: "簽署日期", sortable: true },
    { key: "member_contract_status.name", label: "狀態", sortable: true },
    { key: "approver.name", label: "審批人" },
    { key: "export_contract", label: "合約" },
    { key: "actions", label: "操作" }
  ];
  const perPage = ref(10);
  const totalApproves = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);
  const approvesList = ref([])

  const dataMeta = computed(() => {
    const localItemsCount = refApproveListTable.value
      ? refApproveListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalApproves.value,
    };
  });

  const refetchData = () => {
    refApproveListTable.value.refresh();
  };


  watch(
    [currentPage, perPage, searchQuery],
    () => {
      refetchData();
    }
  );

  const fetchApproves = (ctx, callback) => {
    store
      .dispatch("app-approve/fetchMemberContracts", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { member_contracts, total } = response.data;
        callback(member_contracts);
        // console.log(approves)
        approvesList.value = member_contracts
        totalApproves.value = total;
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取修改資料請求清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const memberContractStatuses = ref([])


  onMounted(() => {
    
    store.dispatch('app/fetchOptionList', {member_contract_status: true})
    .then((response) => {
      memberContractStatuses.value = response.data.member_contract_statuses
    })
    
  })

  return {
    fetchApproves,
    tableColumns,
    perPage,
    currentPage,
    totalApproves,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refApproveListTable,
    ability,
    approvesList,
    refetchData,
    memberContractStatuses
  };
}
